import { QUICK_ADD } from 'permissions/actions'

export const LEAD_STATUS = '@@permissions/policy/leadStatus'

export default {
  [QUICK_ADD]: (user, options) => !!user.is_account_admin && !user.read_only
}
